module.exports = __webpack_public_path__ + "static/prozessanalyse-732f0bfed5638e15dfe91da4b1d6333c.png";